import React from 'react';
import './delete.css';

const DeleteConfirmationModal = ({ show, onClose, onConfirm }) => {
    if (!show) return null;

    return (
        <div className="modal">
            <div className="delete-content">
                <h2>Are you sure you want to delete this issue?</h2>
                <div className="modal-actions">
                    <button className="confirm-button" onClick={onConfirm}>
                        Yes
                    </button>
                    <button className="cancel-button" onClick={onClose}>
                        No
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DeleteConfirmationModal;
